import React from "react";
import View from "views/View";
import CurrentBotHeader from "components/bot/CurrentBotHeader";
import DocumentDrawerMenu from "components/menus/DocumentDrawerMenu";
import { Stack, Button, MenuList } from "@mui/material";
import AIEditor from "components/ai-editor/AIEditor";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { useNavigate } from "react-router-dom";
import DocumentList from "components/ai-editor/DocumentList";
import EditDocumentModal from "components/react-lib/generic-ui/modals/EditDocumentModal";
import { MODALS } from "modals";
import { modalsActions } from "store/react-lib/generic-ui/modals";

export default function AIEditorView() {

  const auth = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isMobile = useIsMobile();
  const DOCUMENT_LIST_WIDTH = 300;

  const handleCreateDocument = async () => {
    try {
      const docSnap = await addDoc(collection(db, "documents"), {
        uid: auth.currentUser.uid,
        createdAt: new Date().getTime(),
      });
      navigate(`/docs/${docSnap.id}`);
    } catch(error) {
      console.log(error);
      toast.error("Couldn't create document");
    }
  }

  return (
    <View
      renderLeftActions={() => {
        return <CurrentBotHeader />;
      }}
      renderRightActions={() => {
        return <DocumentDrawerMenu />;
      }}
    >
      {/* <DocumentsLoader /> */}
      {/* <AttachFileModal
        name={MODALS.attachFileToDocumentModal}
        successCallback={processAttachment}
      /> */}
      <EditDocumentModal
        name={MODALS.createDocumentModalV2}
        title="Create Document"
        documentRef={collection(db, "documents")}
        isCreate={true}
        fieldsToEdit={["name"]}
        createExtraData={{
          uid: auth.currentUser.uid,
          createdAt: new Date().getTime(),
        }}
        fieldConfig={{
          name: { props: { color: "secondary" } },
        }}
        saveCallback={(doc) => navigate(`/docs/${doc.id}`)}
      />
    
      {!isMobile && (
        <Stack p={1}>
          <Stack px={2} pb={1}>
            <Button
              color="primary"
              variant="contained"
              onClick={() =>
                dispatch(modalsActions.openModal(MODALS.createDocumentModalV2))
              }
              // onClick={handleCreateDocument}
            >
              New Document
            </Button>
          </Stack>
          <MenuList
            sx={{
              height: "95%",
              width: `${DOCUMENT_LIST_WIDTH}px`,
              overflowY: "auto",
              overflowX: "none",
              boxSizing: "border-box",
            }}
          >
            <DocumentList />
          </MenuList>
        </Stack>
      )}
      <Stack
        sx={{
          width: `calc(100% - ${isMobile ? 0 : DOCUMENT_LIST_WIDTH}px)`,
          height: "100%",
        }}
      >
        {/* <AttachmentList label="Bot attachments" targetId={botId} />
        <AttachmentList
          label="Document attachments"
          targetId={activeDocumentId}
        /> */}
        {/* <ActiveDocument /> */}
        <AIEditor />
      </Stack>
    </View>
  );
}
